import React from 'react';
import { Container, Col, Row, Card, CardHeader, CardBody, Label, Input, Form, CardTitle, FormGroup } from 'reactstrap';
import styles from '../FileClaim/Payment.module.css';
import Cleave from 'cleave.js/react';
import { DropDownAutoComplete } from '../inputs/DropDownAutoComplete';
import CheckboxInput from './CheckboxInput/CheckboxInput';

export default function PaymentBillingInfo(props) {
    const { state, handleCheckAddress, handleInputChange, handleStateDropDown, validator, whiteLabelBrand } = props;
    let verifiedAddress = state.verifiedAddress;
    const serviceAddress = state.serviceAddress;
    let useServiceAddress = false;

    if (verifiedAddress == null || typeof verifiedAddress.stateId == 'undefined') {
        verifiedAddress = serviceAddress;
        useServiceAddress = true;
    }

    return (
        <div>
            <Label
                htmlFor='billingAddress'
                className='form-label col-12 p-0'
            >
                Billing Address
                <span
                    aria-hidden='true'
                    className='required-indicator'
                >
                    *
                </span>
            </Label>
            <CheckboxInput
                clientId={whiteLabelBrand}
                id='mailingaddress'
                checked={!state.customAddress}
                handleCheck={handleCheckAddress}
            >
                {`Use my ${useServiceAddress ? 'service' : 'mailing'} address`}
            </CheckboxInput>
            {!state.customAddress ? (
                <ul
                    id='billingAddressStatic'
                    className='noBullets pb-3'
                >
                    <li>{verifiedAddress.address1 || ''}</li>
                    <li>{verifiedAddress.address2 || ''}</li>
                    <li>
                        {verifiedAddress.city || ''}, {verifiedAddress.state || ''} {verifiedAddress.zip || ''}
                    </li>
                </ul>
            ) : (
                <div id='billingAddressFields'>
                    <FormGroup
                        className={
                            !validator.check(state.billingAddress.address1, 'required')
                            && state.validationFired
                            && 'form-error'
                        }
                    >
                        <Label
                            htmlFor='billingAddress'
                            className='form-label'
                        >
                            Street Address
                        </Label>
                        <span
                            aria-hidden='true'
                            className='required-indicator'
                        >
                            *
                        </span>
                        <Input
                            type='text'
                            className='form-control'
                            id='billingAddress'
                            name='billingAddress'
                            aria-required='true'
                            onChange={handleInputChange}
                            value={state.billingAddress.address1}
                        />
                        {validator.message('billingAddress', state.billingAddress.address1, 'required')}
                    </FormGroup>
                    <div className='form-group'>
                        <Label
                            htmlFor='billingAddress2'
                            className='form-label'
                        >
                            Apt, Suite, Building
                        </Label>
                        <Input
                            type='text'
                            className='form-control'
                            id='billingAddress2'
                            name='billingAddress2'
                            aria-required='true'
                            onChange={handleInputChange}
                            value={
                                state.billingAddress.address2 === null || state.billingAddress.address2 === undefined
                                    ? ''
                                    : state.billingAddress.address2
                            }
                        />
                    </div>
                    <FormGroup
                        className={
                            !validator.check(state.billingAddress.city, 'required')
                            && state.validationFired
                            && 'form-error'
                        }
                    >
                        <Label
                            htmlFor='billingCity'
                            className='form-label'
                        >
                            City
                        </Label>
                        <span
                            aria-hidden='true'
                            className='required-indicator'
                        >
                            *
                        </span>
                        <Input
                            type='text'
                            className='form-control'
                            id='billingCity'
                            name='city'
                            aria-required='true'
                            onChange={handleInputChange}
                            value={state.billingAddress.city}
                        />
                        {validator.message('city', state.billingAddress.city, 'required')}
                    </FormGroup>
                    <Row className='form-group twoColWrapper'>
                        <div className='col-sm-6'>
                            <label
                                htmlFor='billingState'
                                className='form-label'
                            >
                                State
                            </label>
                            <span
                                aria-hidden='true'
                                className='required-indicator'
                            >
                                *
                            </span>
                            {state.states && (
                                <DropDownAutoComplete
                                    name='state'
                                    options={state.states}
                                    className='form-control'
                                    aria-required='true'
                                    onChangedValue={handleStateDropDown}
                                    isFloatingDropdown={false}
                                    onBlur={handleStateDropDown}
                                    defaultValue={
                                        state.billingAddress.stateId === '' ? undefined : state.billingAddress.stateId
                                    }
                                    Value={state.billingAddress.stateId}
                                />
                            )}
                            {validator.message('state', state.billingAddress.stateId, 'required')}
                        </div>
                        <div className='col-sm-6'>
                            <FormGroup
                                className={
                                    !validator.check(state.billingAddress.zip, 'required|size:5')
                                    && state.validationFired
                                    && 'form-error'
                                }
                            >
                                <Label
                                    htmlFor='zipCode'
                                    className='form-label'
                                >
                                    Zip/Postal Code
                                </Label>
                                <span
                                    aria-hidden='true'
                                    className='required-indicator'
                                >
                                    *
                                </span>
                                <Cleave
                                    options={{ blocks: [5], numericOnly: true }}
                                    className='form-control'
                                    id='zipCode'
                                    name='zipCode'
                                    aria-required='true'
                                    onChange={handleInputChange}
                                    value={state.billingAddress.zip}
                                />
                                {validator.message('zip/postalCode', state.billingAddress.zip, 'required|size:5')}
                            </FormGroup>
                        </div>
                    </Row>
                </div>
            )}
        </div>
    );
}
